import React from 'react'
import { withApp } from 'helpers'

class Event extends React.Component {
  componentDidMount() {
    this.props.app.triggerEvent(false)
  }

  render() {
    const Component = this.props.component

    if(this.props.app.event === this.props.name)
      return <Component {...this.props} />
    else
      return null
  }
}

class EventSwitch extends React.Component {
  render() {
    return React.Children.map(this.props.children, child => {
      return child.props.name === this.props.app.event ? child : null
    })
  }
}

const EventSwitchWithApp = withApp(EventSwitch)

export default withApp(Event)
export { EventSwitchWithApp as EventSwitch }


// WEBPACK FOOTER //
// ./src/components/events/event/Event.js